import "./BorderCircle.scss";

const BorderCircle = ({ children, className }) => {
  return (
    <div
      className={`borderCircle ${
        className ? `borderCircle--${className}` : ""
      }`}
    >
      {children}
    </div>
  );
};

export default BorderCircle;